import React from 'react';
import PropTypes from 'prop-types';
import {
  Body,
  Box,
} from '../../coreui';

const NoInvestments = ({
  emptyText,
}) => {
  return (
    <Box
      w={1}
      py={[20, 40]}
    >
      <Body
        type="B1"
        align="center"
        display="block"
        m={0}
        w={1}
        color="gray.8"
      >
        { emptyText }
      </Body>
    </Box>
  );
};

NoInvestments.propTypes = {
  emptyText: PropTypes.string,
};

export default NoInvestments;
